import React, { useState, useEffect } from 'react';

import './styles.css';

import billServices from '../../../../services/academy/academyBillServices';

import { Dots } from "react-activity";

import Popup from '../../../../components/Popup';
import Input from '../../../../components/Input';
import { FaArrowUp, FaArrowDown, FaFileInvoiceDollar } from 'react-icons/fa';
import companyServices from '../../../../services/admFin/companyServices';

export default function PopupNewBill(props) {
    const [auxInfos, setAuxInfos] = useState({});
    const [costCenter, setCostCenter] = useState("");
    const [partner, setPartner] = useState("");
    const [description, setDescription] = useState("");
    const [currency, setCurrency] = useState("");
    const [numberInstallments, setNumberInstallments] = useState(1);
    const [note, setNote] = useState("");
    const [fetching, setFetching] = useState(false);
    const [installments, setInstallments] = useState([{
        valor: 0,
        data_venc: ""
    }]);

    useEffect(() => {
        if (props.data && props.data.id) {
            setCostCenter(props.data.centro_de_custo);
            setPartner(props.data.parceiro);
            setDescription(props.data.descricao);

            setCurrency(props.data.currency);
            setNumberInstallments(props.data.numero_parcelas);
            setInstallments(props.data.parcelas.filter(obj => obj.paga === false));


            setNote(props.data.obs);
        } else
            cleanStates();
    }, [props.data]);

    /* useEffect(() => {
        if (auxInfos.produtos) {
            let auxArray = auxInfos.produtos.slice();
            if (costCenter)
                auxArray = auxArray.filter(item => item.centro_de_custo.nome === costCenter);
            if (billsPlan)
                auxArray = auxArray.filter(item => item.plano_de_contas.nome === billsPlan);

            if (product && !auxArray.find(item => item.nome === product)) setProduct("");
            setProductsList(auxArray);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auxInfos, costCenter, billsPlan]); */

    /* useEffect(() => {
        if (company) {
            const temp = auxInfos.empresas.find(empresa => empresa.nome === company);
            if (temp)
                setCurrency(temp.moeda);
        }
    }, [company]);

    useEffect(() => {
        let productObj = productsList.find(item => item.nome === product);
        if (product && productObj && (!costCenter || !billsPlan)) {
            if (!costCenter)
                setCostCenter(productObj.centro_de_custo.nome);
            if (!billsPlan)
                setBillsPlan(productObj.plano_de_contas.nome);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product, productsList]);
 */
    function onBlurNumberInstallments(e) {
        if (props.data.numero_parcelas && numberInstallments < props.data.numero_parcelas_pagas) {
            alert("Não é permitido atualizar a conta com menos parcelas que o número de parcelas já pagas");
            setNumberInstallments(props.data.numero_parcelas)
            setInstallments(props.data.parcelas.filter(obj => obj.paga === false));
            return;
        }
        if (props.data.numero_parcelas) {
            if (numberInstallments - props.data.numero_parcelas_pagas > installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments - props.data.numero_parcelas_pagas > temp.length) {
                        temp.push({
                            valor: 0,
                            data_venc: ""
                        });
                    }
                    return temp
                });
            }
            else if (numberInstallments - props.data.numero_parcelas_pagas < installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments - props.data.numero_parcelas_pagas < temp.length) {
                        temp.pop();
                    }
                    return temp;
                });
            }

        }
        else {
            if (numberInstallments > installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments > temp.length) {
                        temp.push({
                            valor: 0,
                            data_venc: ""
                        });
                    }
                    return temp
                });
            }
            else if (numberInstallments < installments.length) {
                setInstallments(oldArray => {
                    const temp = [...oldArray];
                    while (numberInstallments < temp.length) {
                        temp.pop();
                    }
                    return temp;
                });
            }
        }
    }

    /* async function readInfoNewBill() {
        const response = await billServices.getInfoNewBill();
        if (response.status === 200) {
            setAuxInfos(response.data);
        } else
            alert("Erro ao ler informações auxiliares, tente novamente!");
    } */

    async function createBill() {
        if ((props.type === "pagar" || props.type === "receber") && costCenter && partner && description && numberInstallments && installments.length > 0) {
            setFetching(true);
            const response = await billServices.postBill(
                costCenter,
                partner,
                description,
                '0',
                numberInstallments,
                installments,
                note,
                props.type === "pagar" ? 0 : 1,
            );
            setFetching(false);
            if (response.status === 201) {
                if (props.onCreate) props.onCreate();
                props.setVisibility(false);
                cleanStates();
            } else
                alert("Erro ao criar conta, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios");
    }

    async function updateBill() {
        if (costCenter && partner && description && numberInstallments) {
            setFetching(true);
            const response = await billServices.pathcBill(
                props.data.id,
                costCenter,
                partner,
                description,
                '0',
                numberInstallments,
                installments,
                note,
            );
            setFetching(false);
            if (response.status === 200) {
                if (props.onUpdate) props.onUpdate(response.data);
                props.setVisibility(false);
            } else
                alert("Erro ao editar conta, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios");
    }

    function cleanStates() {
        setCostCenter("");
        setPartner("");
        setDescription("");
        setCurrency("");
        //setValue(0);
        setNumberInstallments(1);
        setInstallments([{
            valor: 0,
            data_venc: ""
        }]);
        //setDueDate("");
        setNote("");
    }

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={props.type === "pagar" || (props.data && props.data.tipo === "Pagar") ?
                <FaArrowUp />
                :
                (props.type === "receber" || (props.data && props.data.tipo === "Receber") ?
                    <FaArrowDown />
                    : <FaFileInvoiceDollar />
                )
            }
            tittle={`${props.data && props.data.id ? "Editar" : "Nova"} conta ${props.type || (props.data && props.data.tipo) ? ` a ${props.type ? props.type : props.data.tipo.toLowerCase()}` : ""}`}
        >
            <form>
                <Input
                    label='Centro de custo*'
                    placeholder='Insira um Centro de Custo'
                    id='popup-new-bill-cost-center'
                    onChange={(event) => setCostCenter(event.target.value)}
                    value={costCenter}
                />
                <Input
                    label={props.type === "pagar" ? "Fornecedor*" : (props.type === "receber" ? "Cliente*" : "Parceiro*")}
                    placeholder={`Insira um ${props.type === "pagar" ? "Fornecedor" : (props.type === "receber" ? "Cliente" : "Parceiro")}`}
                    
                    id='popup-new-bill-partner'
                    onChange={(event) => setPartner(event.target.value)}
                    value={partner}
                />
                <Input
                    label='Descrição*'
                    placeholder="Insira uma descrição"
                    type='textarea'
                    id='popup-new-bill-description'
                    onChange={(event) => setDescription(event.target.value)}
                    value={description}
                />
                
                    <Input
                        label='Número de Parcelas*'
                        type="number"
                        min={1}
                        max={24}
                        placeholder="Insira um valor"
                        id='popup-new-bill-installments'
                        onChange={(event) => setNumberInstallments(event.target.value)}
                        value={numberInstallments}
                        onBlur={onBlurNumberInstallments}
                    />
                {/* <Input
                    label="Vencimento*"
                    type='date'
                    id='popup-new-bill-due-date'
                    onChange={(event) => setDueDate(event.target.value)}
                    value={dueDate}
                /> */}
                <Input
                    label='Observação'
                    placeholder="Insira uma observação"
                    type='textarea'
                    id='popup-new-bill-note'
                    onChange={(event) => setNote(event.target.value)}
                    value={note}
                />
                {
                    numberInstallments ?
                        installments.map((obj, idx) => (
                            <div className='line' key={idx}>
                                <Input
                                    label={`Vencimento Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                    type='date'
                                    id='popup-new-bill-due-date'
                                    onChange={(event) => {
                                        setInstallments(oldArray => {
                                            const temp = [...oldArray];
                                            temp[idx].data_venc = event.target.value;
                                            return temp;
                                        })
                                    }}
                                    value={installments[idx].data_venc}
                                />
                                <Input
                                    label={`Valor Parcela ${/* props.data.parcelas ? idx+1+(props.data.parcelas.length - installments.length) : */  idx + 1}*`}
                                    type="currency"
                                    currency={currency}
                                    placeholder="Insira um valor"
                                    id='popup-new-bill-value'
                                    onChange={(event) => {
                                        setInstallments(oldArray => {
                                            const temp = [...oldArray];
                                            temp[idx].valor = event.target.value;
                                            return temp;
                                        })
                                    }}
                                    value={installments[idx].valor}
                                />
                            </div>
                        ))
                        :
                        null
                }
                <button
                    type="button"
                    onClick={() => fetching ? alert("Um envio já está em andamento.") : (props.data && props.data.id ? updateBill() : createBill())}
                >
                    {
                        fetching ?
                            <Dots />
                            : (props.data && props.data.id ? "Salvar" : "Adicionar")
                    }
                </button>
            </form>
        </Popup>
    )
}